<template>
  <div class="container">
    <v-card>
      <v-toolbar class="mt-12" dark color="primary">
        <v-toolbar-title>Configuración de Cajas</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <!-- ABM de Cajas -->
        <v-row>
          <v-col cols="12">
            <v-chip label color="transparent" text-color="black">
              <h3>Cajas</h3>
            </v-chip>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headersCajas"
          :items="cajas"
          class="elevation-1"
          :hide-default-footer="true"
          :items-per-page="50"
          locale="es-ar"
        >
          <template v-slot:item.activa="{ item }">
            <v-simple-checkbox v-model="item.activa" disabled></v-simple-checkbox>
          </template>
          <template v-slot:item.esDefault="{ item }">
            <v-simple-checkbox v-model="item.esDefault" disabled></v-simple-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon color="purple" class="mr-2" @click="editarCaja(item)">mdi-pencil</v-icon>
          </template>
        </v-data-table>

        <v-row class="mt-3">
          <v-col cols="12" sm="4" md="3">
            <v-text-field v-model="nuevaCajaNombre" label="Nombre nueva caja" dense></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <v-btn color="success" @click="agregarCaja" :disabled="!nuevaCajaNombre">
              <v-icon left>mdi-plus</v-icon> Agregar
            </v-btn>
          </v-col>
        </v-row>

        <!-- Mapeo Forma de Pago → Caja -->
        <v-row class="mt-6">
          <v-col cols="12">
            <v-chip label color="transparent" text-color="black">
              <h3>Mapeo: Forma de Pago → Caja destino</h3>
            </v-chip>
            <p class="text-body-2 grey--text mt-1">
              Define a qué caja va el dinero según la forma de pago seleccionada en un cobro.
            </p>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headersMapeo"
          :items="mapeos"
          class="elevation-1"
          :hide-default-footer="true"
          :items-per-page="50"
          locale="es-ar"
        >
          <template v-slot:item.idCaja="{ item }">
            <v-select
              :items="cajasActivas"
              item-text="nombreCaja"
              item-value="idCaja"
              v-model="item.idCaja"
              dense
              hide-details
              class="mt-0 pt-0"
              placeholder="Sin asignar"
              clearable
            ></v-select>
          </template>
        </v-data-table>

        <v-row class="mt-3" justify="end">
          <v-col cols="auto">
            <v-btn color="primary" @click="guardarMapeos">
              <v-icon left>mdi-content-save</v-icon> Guardar Mapeos
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn dark color="#24232d" @click="$router.push('/caja/cajas')">
          <v-icon left>mdi-arrow-left</v-icon> Volver
        </v-btn>
      </v-card-actions>

      <!-- Dialog Editar Caja -->
      <v-dialog v-model="showEditarCaja" max-width="400" persistent>
        <v-card>
          <v-toolbar dark color="purple" dense>
            <v-toolbar-title>Editar Caja</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="showEditarCaja = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <v-text-field v-model="editCaja.nombreCaja" label="Nombre *" dense></v-text-field>
            <v-checkbox v-model="editCaja.activa" label="Activa" dense></v-checkbox>
            <v-checkbox v-model="editCaja.esDefault" label="Es Default" dense></v-checkbox>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showEditarCaja = false">Cancelar</v-btn>
            <v-btn color="purple" dark @click="guardarEditCaja">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<style scoped>
.container { margin: auto; }
</style>

<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";

export default {
  data: () => ({
    cajas: [],
    cajasActivas: [],
    mapeos: [],
    nuevaCajaNombre: "",
    headersCajas: [
      { text: "Nombre", value: "nombreCaja" },
      { text: "Activa", value: "activa" },
      { text: "Default", value: "esDefault" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    headersMapeo: [
      { text: "Forma de Pago", value: "nombreFormaPago" },
      { text: "Caja Destino", value: "idCaja" },
    ],
    showEditarCaja: false,
    editCaja: {},
  }),
  methods: {
    async cargarCajas() {
      try {
        const { data } = await axios.get("/Caja/BuscarCajas");
        this.cajas = data;
        this.cajasActivas = data.filter((c) => c.activa);
      } catch (e) { /* silenciar */ }
    },
    async cargarMapeos() {
      try {
        const { data } = await axios.get("/Caja/BuscarFormaPagoCaja");
        this.mapeos = data;
      } catch (e) { /* silenciar */ }
    },
    async agregarCaja() {
      try {
        await axios.post("/Caja/GuardarCaja", {
          idCaja: 0,
          nombreCaja: this.nuevaCajaNombre,
          idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          activa: true,
          esDefault: false,
        });
        showAlert({ icon: "success", title: "Caja creada.", vm: this, timer: 1500 });
        this.nuevaCajaNombre = "";
        this.cargarCajas();
      } catch (e) {
        showAlert({ icon: "warning", title: "Error al crear la caja.", vm: this, timer: 2500 });
      }
    },
    editarCaja(item) {
      this.editCaja = { ...item };
      this.showEditarCaja = true;
    },
    async guardarEditCaja() {
      try {
        await axios.post("/Caja/GuardarCaja", this.editCaja);
        showAlert({ icon: "success", title: "Caja actualizada.", vm: this, timer: 1500 });
        this.showEditarCaja = false;
        this.cargarCajas();
      } catch (e) {
        showAlert({ icon: "warning", title: "Error al actualizar la caja.", vm: this, timer: 2500 });
      }
    },
    async guardarMapeos() {
      try {
        await axios.post("/Caja/GuardarFormaPagoCaja", this.mapeos);
        showAlert({ icon: "success", title: "Mapeos guardados.", vm: this, timer: 1500 });
      } catch (e) {
        showAlert({ icon: "warning", title: "Error al guardar los mapeos.", vm: this, timer: 2500 });
      }
    },
  },
  async created() {
    await this.cargarCajas();
    await this.cargarMapeos();
  },
};
</script>